import { HttpClient } from '@angular/common/http';
export class Key {
    keyGuid: string;
    invoiceGuid: string;
    invoiceId: string;
    created: Date;
    numberOfPcs: number;
    activations: KeyActivation[];
    isEdit: boolean = false;
    currentState: any;
    comment: string;
    status: string;
    public constructor(private http: HttpClient) {

    }
    public returnInfo() {
        this.isEdit = false;

        this.keyGuid = this.currentState.key;
        this.comment = this.currentState.comment;
    }

    public saveCurrentInfo() {
        this.isEdit = true;

        this.currentState = {
            key: this.keyGuid,
            comment: this.comment
        };
        console.log(this.currentState);
    }

    // public changeStatus(keyStatus) {
    //     keyStatus = "revoked"
    //     console.log(keyStatus);
    //     this.http.post('http://localhost:3000/api/admin/changeStatus', {status: keyStatus,
    //     key: this.keyGuid}).subscribe((data: any) => {
    //         console.log(data);
    //     });
    // }

    public saveInfo() {
        this.isEdit = false;

        this.http.post(remoteApiHost + 'api/admin/giveInvoiceInfo', {key: this.keyGuid,
        comment: this.comment,
        invoiceId: this.invoiceId}).subscribe((data: any) => {
        });

    }

}

export interface KeyActivation {
    activationDate: string;
    keyGuid: string;
    machineGuid: string;
    status: string;
    actId: string;
}


// WEBPACK FOOTER //
// ./src/app/admin/keys/key.ts